import config from "@/common/config";

// Get a config by key with dot notation "my.specific.value"
const getConfigByKey = (key) => key.split(".").reduce((o, i) => o[i], config);

const ConfigService = {
  install: function (app) {
    // Allows us to use this.$config in any component
    app.config.globalProperties.$config = getConfigByKey;
  }
};

export default ConfigService;
